import React from 'react'
import { CardHeader, Heading, Text, Flex, Image, Button, useModal } from '@pixel-nft/uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Pool } from 'state/types'
import { getFullDisplayBalance, getBalanceNumber, formatNumber } from 'utils/formatBalance'
import BigNumber from 'bignumber.js'
import { BIG_ZERO } from 'utils/bigNumber'
import { PoolCategory } from 'config/constants/types'
import { useBusdPriceFromToken } from 'state/hooks'
import UnlockButton from 'components/UnlockButton'
import { NoFees } from 'components/Tags'
import ApprovalAction from './CardActions/ApprovalAction'
import StakeActions from './CardActions/StakeActions'
import CollectModal from './Modals/CollectModal'

const Wrapper = styled(CardHeader)<{ isFinished?: boolean; background?: string; isPromotedPool?: boolean }>`
  // background: ${({ isFinished, background, theme }) =>
    isFinished ? theme.colors.backgroundDisabled : theme.colors.gradients[background]};
  background: #213a6c;
  border-radius: ${({ theme, isPromotedPool }) =>
    isPromotedPool ? '31px 31px 0 0' : `${theme.radii.card} ${theme.radii.card} 0 0`};
`

const StyledCardHeaderNew: React.FC<{
  earningTokenSymbol: string
  stakingTokenSymbol: string
  isAutoVault?: boolean
  isFinished?: boolean
  isStaking?: boolean
  isPromotedPool?: boolean
}> = ({
  earningTokenSymbol,
  stakingTokenSymbol,
  isFinished = false,
  isAutoVault = false,
  isStaking = false,
  isPromotedPool = false,
}) => {
  const { t } = useTranslation()
  const poolImageSrc = isAutoVault
    ? `cake-cakevault.svg`
    : `${earningTokenSymbol}-${stakingTokenSymbol}.svg`.toLocaleLowerCase()
  const isCakePool = earningTokenSymbol === 'CAKE' && stakingTokenSymbol === 'CAKE'

  const getHeadingPrefix = () => {
    if (isAutoVault) {
      // vault
      return t('Auto')
    }
    if (isCakePool) {
      // manual cake
      return t('Manual')
    }
    // all other pools
    return t('Earn')
  }

  return (
    <Wrapper isPromotedPool={isPromotedPool} isFinished={isFinished}>
      <Flex alignItems="center" flexDirection="column" style={{ width: '100%' }}>
        <Flex flexDirection="row" justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
          <Image src={`/images/pools/${poolImageSrc}`} alt={earningTokenSymbol} width={50} height={50} />
          <Text textAlign="right">
            <Heading mb="10px" color="cardHeading">
              {`${getHeadingPrefix()} ${earningTokenSymbol}`}
            </Heading>
            <NoFees />
          </Text>
        </Flex>
      </Flex>
    </Wrapper>
  )
}

export default StyledCardHeaderNew
